import { isServer } from './is-server'

export const base64Decode = (data: string) => {
  if (!isServer) {
    return JSON.parse(window.atob(data.replace('==', '')))
  }
  if (isServer) return JSON.parse(Buffer.from(data, 'base64').toString())
}
